import { render } from "./CharlaFooter.vue?vue&type=template&id=0bb461d0&scoped=true"
import script from "./CharlaFooter.vue?vue&type=script&lang=js"
export * from "./CharlaFooter.vue?vue&type=script&lang=js"

import "./CharlaFooter.vue?vue&type=style&index=0&id=0bb461d0&scoped=true&lang=sass"
import "./CharlaFooter.vue?vue&type=style&index=1&id=0bb461d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb461d0"]])

export default __exports__